module.exports = __webpack_public_path__ + "static/media/baaa.08085e89.ogg";